import { request } from "../utils/request.js"


export const commodity_addNew = (pojo, args) => request({
    url: 'commodity/addNew',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodity_update = (pojo, args) => request({
    url: 'commodity/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodity_findPageForManage = (pojo, args) => request({
    url: 'commodity/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodity_findPageForSelect = (pojo, args) => request({
    url: 'commodity/findPageForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodity_exportForUpdate = (pojo, args) => request({
    url: 'commodity/exportForUpdate',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodity_changeFrozenStatus = (id, args) => request({
    url: 'commodity/changeFrozenStatus',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodity_deleteById = (id, args) => request({
    url: 'commodity/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})


export const commodity_findById = (id, args) => request({
    url: 'commodity/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const commodity_findVoById = (id, args) => request({
    url: 'commodity/findVoById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const commodity_findVoByIdIn = (pojo, args) => request({
    url: 'commodity/findVoByIdIn',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/commodity.js